import {getRecentDisplayedNumber} from './analytics';

export function isGoogle(selectionType) {
    return selectionType === 'google';
}

function getSelectionType(poweredByGoogle) {
    return poweredByGoogle ? 'google' : 'standard';
}

function getGoogleSelectionPlaceIdObject(selectionType, uuid) {
    return isGoogle(selectionType) ? {googleselectionplaceid: uuid} : {};
}

function getResultsUuidObject(resultsUuid) {
    return resultsUuid ? {resultsuuid: resultsUuid} : {};
}

function getGeoSystemType(result) {
    if (result.google) {
        return 'GOOGLE';
    }
    return 'GAIA';
}

function buildSuggestionList(results) {
    return results.map((result) => {
        const sourceSystem = getGeoSystemType(result);
        return {
            sourceSystem,
            id: result.gaiaId || result.uuid,
            type: result.type
        };
    });
}

export function buildSelectionEventPayload({
    destination,
    results,
    userInput,
    analytics: {
        backspaceCounter,
        noSelectionCounter,
        prevSearch,
        resultsUuid,
        selectionDepth
    }
}) {
    const selectionType = getSelectionType(destination.poweredByGoogle);
    const resultsUuidObject = getResultsUuidObject(resultsUuid);
    const googleSelectionPlaceIdObject = getGoogleSelectionPlaceIdObject(
        selectionType,
        destination.uuid
    );
    const sourcesystem = getGeoSystemType(destination);

    let recentsDisplayed = 0;
    let totalResults = 0;
    let suggestionlist = [];

    if (results) {
        recentsDisplayed = getRecentDisplayedNumber(results);
        if (!isGoogle(selectionType)) {
            totalResults = results.length - recentsDisplayed;
        }
        suggestionlist = buildSuggestionList(results);
    }

    return {
        userinput: userInput,
        totalbackspaces: backspaceCounter,
        totalnoselections: noSelectionCounter,
        totalresults: totalResults,
        selectiondepth: destination.suggestionDepth || selectionDepth,
        selectiontype: selectionType,
        recentsdisplayed: recentsDisplayed,
        prevsearch: prevSearch,
        geouuid: destination.uuid,
        geotypes: destination.type,
        geoname: destination.term,
        matchtype: destination.matchType,
        suggestionlist,
        sourcesystem,
        searchdestinationid: destination.gaiaId || destination.uuid,
        ...resultsUuidObject,
        ...googleSelectionPlaceIdObject
    };
}
